import { render, staticRenderFns } from "./NpaDeveloper.vue?vue&type=template&id=4dca0e4f"
import script from "./NpaDeveloper.vue?vue&type=script&lang=js"
export * from "./NpaDeveloper.vue?vue&type=script&lang=js"
import style0 from "./NpaDeveloper.vue?vue&type=style&index=0&id=4dca0e4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports